import { render } from "./Glosario.vue?vue&type=template&id=83242304"
import script from "./Glosario.vue?vue&type=script&lang=js"
export * from "./Glosario.vue?vue&type=script&lang=js"

import "./Glosario.vue?vue&type=style&index=0&id=83242304&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__